import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Results from "./Results";
import UploadPage from "./Upload";


function App() {
  const [loading, setLoading] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [uploadType, setUploadType] = useState('');

  useEffect(() => {}, [percentage, uploadType]);

  return (
    <div>
      {loading && <div className='loader'>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><linearGradient id="a3"><stop offset="0" stop-color="#000000" stop-opacity="0"></stop><stop offset="1" stop-color="#000000"></stop></linearGradient><circle fill="none" stroke="url(#a3)" stroke-width="15" stroke-linecap="round" stroke-dasharray="0 44 0 44 0 44 0 44 0 360" cx="100" cy="100" r="70" transform-origin="center"><animateTransform type="rotate" attributeName="transform" calcMode="discrete" dur="2" values="360;324;288;252;216;180;144;108;72;36" repeatCount="indefinite"></animateTransform></circle>
          { percentage !== 0 && <text x="100" y="110" text-anchor="middle" font-size="30" fill="white" font-family="Arial" dominant-baseline="middle">
            <tspan x="100" dy="-15" className="upload-type">{uploadType}</tspan>
            <tspan x="100" dy="30" className="upload-type">{percentage}%</tspan>
          </text> }
        </svg>
        </div>}
      <Router>
        <Routes>
          <Route path="/" element={<UploadPage setLoading={setLoading} setPercentage={setPercentage} setUploadType={setUploadType}/>}  />
          <Route path="/results" element={<Results setLoading={setLoading}/>} />

          <Route path="/formatcheck" element={<Navigate to="/" />}  />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
